import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import shubh1 from "../assets/shubh1.webp";
import shubh2 from "../assets/shubh2.webp";
import shubh3 from "../assets/shubh3.webp";
import shubh4 from "../assets/shubh4.webp";

const ShubhPaisaSection = () => {
  return (
    <>
      <div className="container-shubhpaisa position-relative">
        <div className="shubh-blur-top-right"></div>
        <div className="shubh-blur-bottom-left"></div>
        <div className="text-center pt-5 pb-5 px-3 px-lg-0 mx-0">
          <h2 className="mt-5 mb-4 fw-semibold">What is Shubh Paisa?</h2>
          <p className="mx-auto px-3 px-md-0" style={{ maxWidth: "650px" }}>
            <strong>
              Shubh Paisa isn’t just another finance company—it’s your financial
              co-pilot.
            </strong>{" "}
            Whether you need funds to fuel your ambitions, security for your
            loved ones, or a smoother way to manage payments, we bring solutions
            that work for you, not just the banks.
            <br />
            Because your financial story deserves{" "}
            <strong>clarity, confidence, and control</strong>.
          </p>

          <div className="row g-4 justify-content-center align-items-stretch my-3">
            <div className="col-6 col-sm-6 col-md-2">
              <div className="h-100 image-layer">
                <img
                  src={shubh1}
                  className="rounded-3 object-fit-cover w-100 h-100"
                  alt="Wallet"
                />
              </div>
            </div>

            <div className="col-6 col-sm-6 col-md-2 order-md-3">
              <div className="h-100 image-layer">
                <img
                  src={shubh3}
                  className="rounded-3 object-fit-cover w-100 h-100"
                  alt="Finance Table"
                />
              </div>
            </div>

            <div className="col-12 col-md-4 order-md-2">
              <div className="d-flex flex-column gap-4 h-100">
                <div className="h-50 image-layer">
                  <img
                    src={shubh2}
                    className="rounded-3 object-fit-cover w-100 h-100"
                    alt="Happy Team"
                  />
                </div>
                <div className="h-50 image-layer">
                  <img
                    src={shubh4}
                    className="rounded-3 object-fit-cover w-100 h-100"
                    alt="Team Working"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShubhPaisaSection;
